<template>
  <Select v-model="selected" @on-select="handleSelect" :clearable="clearable" :placeholder="$t('order.product_type_select_placeholder')">
    <Option v-for="p in productTypes" :key="p.value" :value="p.value">{{ p.label }}</Option>
  </Select>
</template>

<script>
export default {
  name: 'ProductTypeSelect',
  props: {
    clearable: Boolean
  },
  data () {
    return {
      selected: this.$attrs.value,
      productTypes: [
        { value: 'old', label: 'A 老产品' },
        { value: 'changed_little', label: 'B 略有改动，但不需要测试' },
        { value: 'changed_a_lot', label: 'C 改动较大，需要重新测试' },
        { value: 'new', label: 'D 新产品' }
      ]
    }
  },
  methods: {
    handleSelect (item) {
      this.$emit('input', item.value)
    }
  }
}
</script>
